// Angular + External modules
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FlexLayoutModule } from "@angular/flex-layout";
import { RouterModule, RouterOutlet } from "@angular/router";
// @bfx/primeng
import { PanelModule } from "@bfx/primeng/panel";
import { ButtonModule } from "@bfx/primeng/button";
// BFX
import { LoginComponent } from "./login.component";
import { LogoutComponent } from "./logout.component";
import { LoaderComponent } from "./loader.component";

import { BfxElementsLibraryModule } from "./../bfx-element-library/bfx-elements-library.module";
import { BfxChangePasswordComponent } from "./bfx-change-password.component";
import { RestartLogoutComponent } from "./restart-logout.component";
import { CloseComponent } from "./bfx-close.component";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { LoaderService } from "./loader.service";
import { SSOLoginComponent } from "./sso-login.component";
import { BrandingComponentsModule } from "shared/branding/branding-components.module";

@NgModule({
  declarations: [
    LoginComponent,
    LogoutComponent,
    RestartLogoutComponent,
    LoaderComponent,
    BfxChangePasswordComponent,
    CloseComponent,
    SSOLoginComponent,
  ],
  exports: [
    LoginComponent,
    LogoutComponent,
    BfxChangePasswordComponent,
    CloseComponent,
    SSOLoginComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    BrowserModule,
    PanelModule,
    ButtonModule,
    FlexLayoutModule,
    NativeDesktopModule,
    BfxElementsLibraryModule,
    BrandingComponentsModule,
  ],
  providers: [LoaderService, provideHttpClient(withInterceptorsFromDi())],
})
export class AuthModule {}
